var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagedModeCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8066_8047)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8066_8047",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8066_8047)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8066_8047",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8066_8047)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8066_8047)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8066_8047",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 15,
    height: 15
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H5V19H20V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8066_8047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0274 12.7505H9.97362C9.15224 12.7515 8.36478 13.0782 7.784 13.659C7.20321 14.2399 6.87646 15.0273 6.87549 15.8486V19.0005H18.1255V15.8486C18.1244 15.0273 17.7977 14.2399 17.2169 13.659C16.6361 13.0782 15.8488 12.7515 15.0274 12.7505Z",
    fill: "url(#paint1_linear_8066_8047)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.501 11.5C14.572 11.5 16.251 9.82108 16.251 7.75002C16.251 5.67894 14.572 4 12.501 4C10.4299 4 8.75098 5.67894 8.75098 7.75002C8.75098 9.82108 10.4299 11.5 12.501 11.5Z",
    fill: "url(#paint2_linear_8066_8047)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8066_8047",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8066_8047",
    x1: 12.5005,
    y1: 12.7505,
    x2: 12.5005,
    y2: 19.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8066_8047",
    x1: 12.501,
    y1: 4,
    x2: 12.501,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8066_8047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagedModeCustomer);
export default __webpack_public_path__ + "static/media/ManagedMode-Customer.a51a0770cb744b050d6f8dee679d20e2.svg";
export { ForwardRef as ReactComponent };